import AddNewSL from '../ShippingLocationsPage/Modals/EditOrAddModal';

const CollectInformationModal = ({open, setOpen, formik}) => {

    const setBillToData = (values) => {
        formik.setFieldValue('billToData', values)
    }

    return (
        <AddNewSL
            open={open}
            setOpen={setOpen}
            addOrEdit='collectLocation'
            getData={null}
            setBillToData={setBillToData}
            results={null}
            collectData={formik.values.billToData}
        />
    )
}

export default CollectInformationModal